import React, { useState, useCallback } from "react";
import ImageViewer from "react-simple-image-viewer";

export const Pride = props => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const data = [
    { thumb: "img/pride/01-small.jpg", title: "LGBTQIACOM" },
    { thumb: "img/pride/02-small.jpg", title: "LGBTQIACOM" },
    { thumb: "img/pride/03-small.jpg", title: "LGBTQIACOM" },
    { thumb: "img/pride/04-small.jpg", title: "LGBTQIACOM" },
    { thumb: "img/pride/05-small.jpg", title: "LGBTQIACOM" },
    { thumb: "img/pride/06-small.jpg", title: "LGBTQIACOM" },
    { thumb: "img/pride/07-small.jpg", title: "LGBTQIACOM" },
    { thumb: "img/pride/08-small.jpg", title: "LGBTQIACOM" },
    { thumb: "img/pride/09-small.jpg", title: "LGBTQIACOM" }
  ];

  const images = data.map(obj => obj.thumb.replace("-small", "-large"));

  const openImageViewer = useCallback(index => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <div id="pride" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Pride</h2>
          <p>Our work at LGBTQIACOM organization extends to all communities in the world</p>
        </div>
        <div className="row">
          <div className="pride-items">
            {data.map(({ title, thumb }, index) => (
              <div key={index} onClick={() => openImageViewer(index)} className="col-sm-6 col-md-4 col-lg-4">
                <div className="pride-item cursor">
                  <div className="hover-bg">
                    <div className="hover-text">
                      <h4>{title}</h4>
                    </div>
                    <img src={thumb} className="img-responsive" alt="Project Title" />{" "}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {isViewerOpen && (
            <ImageViewer
              src={images}
              backgroundStyle={{ zIndex: 99999 }}
              currentIndex={currentImage}
              onClose={closeImageViewer}
            />
          )}
        </div>
      </div>
    </div>
  );
};
